<template>
	<div>
		<v-card-title class="title-wrap">
			<h3>
				Historique de vos Demandes de Paiement d’Astreintes (DPA) par journée
			</h3>
			<v-spacer />
		</v-card-title>
		<v-data-table
			:headers="headers"
			:items="historiqueDpas"
			item-key="id"
			:loading="loading"
			:loading-text="loadingText"
			no-data-text="aucune donnée trouvée"
			sort-by="jour"
			sort-desc
			must-sort
		>
			<template #progress>
				<v-progress-linear
					color="#00749c"
					:indeterminate="true"
					:value="100"
					height="1"
				/>
			</template>
			<template #item.sommeMontantGardes="{ item }">
				{{ item.sommeMontantGardes | formatMontant }}
			</template>
			<template #item.jour="{ item }">
				{{ item.jour | formatDate }}
			</template>

			<template #item.actions="{ item }">
				<v-btn
					icon
					:title="'Consulter le PDF récapitulatif des DPA pour la journée'"
					@click="viewPreuve(item)"
				>
					<v-icon> {{ iconPdfBox }}</v-icon>
				</v-btn>
			</template>
		</v-data-table>
	</div>
</template>

<script lang="ts">
	import Component, { mixins } from 'vue-class-component';

	import UserMixin from '@/mixins/userMixin';
	import PdfMixins from '@/mixins/pdfMixins';

	const MixinsDeclaration = mixins(UserMixin, PdfMixins);

	import { DataOptions } from 'vuetify';

	import { HistoriqueDpa } from '@/services/api/types';

	import { StateEnum } from '@cnamts/vue-dot/src/constants/enums/StateEnum';
	import { store } from '@/store';
	import { mdiCheck, mdiClose, mdiPencil, mdiFilePdfBox } from '@mdi/js';
	import { Garde } from '@/services/api/types';
	import { formatDate } from '@/services/dateFormatter';
	import { getDpaFromApi } from '@/services/api/api';

	@Component<Historique>({
		created() {
			this.fetchData();
		}
	})
	export default class Historique extends MixinsDeclaration {
		private historiqueDpas: HistoriqueDpa[] = [];

		search = '';
		iconMDICancel = mdiClose;
		iconMDICheck = mdiCheck;
		iconMdiPencil = mdiPencil;
		iconPdfBox = mdiFilePdfBox;

		StateEnum = StateEnum;

		state = StateEnum.IDLE;

		dataOptions = {} as DataOptions;

		afficherActionSupplementaire = false;
		modalTitre = '';
		gardesDpa: Garde[] = [];
		modalFooterAction = '';
		modalLibelleAction = '';
		loading = false;
		loadingText = 'Chargement de vos dpa en cours...';
		statut: string | null = '';

		headers = [
			{
				value: 'jour',
				text: 'Journée'
			},
			{
				value: 'nbGardes',
				text: 'Nombre de gardes'
			},
			{
				value: 'sommeMontantGardes',
				text: 'Montant total'
			},
			{
				text: 'Document',
				value: 'actions',
				align: 'center',
				sortable: false
			}
		];
		async fetchData(): Promise<void> {
			try {
				this.loading = true;
				let historiqueDpas = null;

				const response = await getDpaFromApi();
				if (response && response.status === 200) {
					historiqueDpas = response.data;
				}

				if (historiqueDpas) {
					this.historiqueDpas = historiqueDpas;
				}
			} catch (error) {
				store.dispatch('notification/add', {
					type: 'error',
					message: 'Une erreur est survenue lors de l\'historique des Dpa'
				});
			} finally {
				this.loading = false;
			}
		}

		viewPreuve(dpa: HistoriqueDpa | null = null): void {
			let dateJour = '';
			if (dpa && dpa.jour) {
				dateJour = dpa.jour;
			} else {
				const currentDate = new Date();
				dateJour = currentDate.toISOString().slice(0, 10);
			}
			this.getPdfDpa(formatDate(dateJour));
		}
	}
</script>
<style lang="scss" scoped>
.modal__content {
  padding: 30px 16px;
}

//}
</style>
